export default __webpack_public_path__ + "static/media/Article_or_Guideline.4bb0c129.svg";